export default __webpack_public_path__ + "static/hero-d@3x-9d581de2a6a9376eee15c14812911139.webp";